import { useEffect, useState } from 'react';
import css from './ProviderImage.module.css';
import { DoctorImage } from '../../../assets/images';

export interface ProviderImageProps {
  cattailsProviderNumber?: string;
}

const determineImageSource = (
  cattailsProviderNumber: string | undefined
): string => {
  return cattailsProviderNumber
    ? `https://www.marshfieldclinic.org/PROVIDERIMAGES/${cattailsProviderNumber}.jpg`
    : DoctorImage;
};

const ProviderImage = (props: ProviderImageProps): JSX.Element => {
  const [imageSrc, setImageSrc] = useState<string>(
    determineImageSource(props.cattailsProviderNumber)
  );

  useEffect(() => {
    setImageSrc(determineImageSource(props.cattailsProviderNumber));
  }, [props.cattailsProviderNumber]);

  return (
    <div className={css.container}>
      <img
        alt=""
        className={css.image}
        src={imageSrc}
        onError={() => setImageSrc(DoctorImage)}
      />
    </div>
  );
};
export default ProviderImage;
